import Tree, { TreeNode } from 'rc-tree'
import React, { Component, useState } from 'react'
import { withTranslation } from 'react-i18next'
import { Button, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'

class TreeView1 extends Component {
	constructor(props) {
		super(props)
		const { keys } = props
		this.state = {
			defaultExpandedKeys: keys,
			defaultSelectedKeys: keys,
			defaultCheckedKeys: keys,
			key: null,
			SelectedKey: null,
			modal: false,
			deleteModal: false,
			deleteModalData: {},
			treeData: [this.props.treeData],
			itemData: [],
			modalData: {},
			formFields: null,
			error: null,
			levelLabels: [],
		}

		this.treeRef = React.createRef()
	}
	componentWillReceiveProps(props) {
		if (props.error && props.error != '') this.setState({ error: props.error })

		this.setState({
			treeData: props.treeData,
			itemData: props.itemData,
			formFields: props.meta && props.meta.fields ? props.meta.fields : null,
			levelLabels: props.levelLabels || [],
		})
	}

	onExpand = expandedKeys => {
		//console.log('onExpand', expandedKeys);
	}

	onSelect = (selectedKeys, info) => {
		//console.log('selected', selectedKeys, info);
		this.selKey = info.node.props.eventKey
		if (selectedKeys[0]) {
			this.setState({
				IsSelected: !this.state.IsSelected,
				SelectedKey: selectedKeys[0],
				selectedKeys: [selectedKeys[0]],
				isNewAdd: false,
				isEditable: false,
				loadingOption: false,
			})
		}
	}

	onCheck = (checkedKeys, info) => {
		//console.log('onCheck', checkedKeys, info);
	}

	getItem(id) {
		const { itemData } = this.state
		return itemData && itemData.find(x => x.id == id)
	}

	searchChild(name) {
		const { itemData } = this.state
		return itemData && itemData.filter(x => x.parentName && x.parentName === name)
	}

	onAddParent = parentLevel => {
		let nextLevel = parentLevel && parentLevel.level ? parentLevel.level : 1
		let { t } = this.props
		let addModal = this.props.createAddModal(null, nextLevel, t)
		if (addModal) {
			let modalData = {
				item: addModal,
				levelLabel: parentLevel.label || parentLevel.name,
				action: {
					buttonLabel: t('Add'),
					ModalHeader: `${t('Create New')} ${parentLevel.label || parentLevel.name}`,
				},
			}
			this.setState({ modal: true, modalData })
		} else this.setState({ error: t('Error Occur in Create Add Modal, Please Contact Admin!') })
	}
	onAdd = (item, nextLevel) => {
		let { t } = this.props
		let addModal = this.props.createAddModal(item, nextLevel.level, t)
		if (addModal) {
			let modalData = {
				item: addModal,
				levelLabel: nextLevel.label || nextLevel.name,
				action: {
					buttonLabel: t('Add'),
					ModalHeader: `${t('Create New')} ${nextLevel.label || nextLevel.name}`,
				},
			}
			this.setState({ modal: true, modalData })
		} else this.setState({ error: t('Error Occur in Create Add Modal, Please Contact Admin!') })
	}
	onEdit = (item, levelLabel) => {
		let selectedItem = this.getItem(item.id)
		if(item?.label)
			selectedItem.label=item?.label
		
		let modalData = {
			item: selectedItem || item,
			levelLabel,
			action: {
				buttonLabel: 'Update',
				ModalHeader: `Edit ${levelLabel} :: ${item.label}`,
			},
		}
		this.setState({ modal: true, modalData })
	}

	onDel = item => {
		const {t} = this.props
		let selectedItem = this.getItem(item.id)
		let deleteModalData = {}
		let findChild = item && item.children && Array.isArray(item.children) && item.children.length > 0 && item.children.find(x => x.status != 'Deleted')
		if (findChild && findChild.name) deleteModalData = { item: selectedItem, message: t('Cannot Delete this Category child categories exists!'), action: false }
		else deleteModalData = { item: selectedItem, message: t('Are you Sure to Delete?'), action: true }

		this.setState({ deleteModal: true, deleteModalData })
	}

	setTreeRef = tree => {
		this.tree = tree
	}
	toggleModal() {
		this.setState({ modal: !this.state.modal })
	}

	toggleDeleteModal() {
		this.setState({ deleteModal: !this.state.deleteModal })
	}

	getNestedChildren(metaDeta, parent) {
		var out = []
		for (var i in metaDeta) {
			if (metaDeta[i].parentName === parent && metaDeta[i].status != 'Deleted') {
				var children = this.getNestedChildren(metaDeta, metaDeta[i].name)
				if (children.length) {
					metaDeta[i].children = children
				}
				out.push(metaDeta[i])
			}
		}
		return out
	}

	renderUi(rowdata) {
		const { t } = this.props
		const { SelectedKey, levelLabels } = this.state
		let level = levelLabels && levelLabels.filter(d => d.level === rowdata.level)
		level = level && level.length > 0 ? level[0] : ''
		let nextLevel = levelLabels && levelLabels.filter(d => d.level === level.level + 1)
		nextLevel = nextLevel && nextLevel.length > 0 ? nextLevel[0] : ''

		const customLabel = Title => (
			<div className="cus-label">
				<span className="label-title"> {t(Title)}</span>
				{SelectedKey == rowdata.id && (
					<span className="al-icon-col" onClick={this.onEdit.bind(this, rowdata, level.label || null, 'Edit')}>
						<i className="fa fa-pencil-square-o fa-lg text-primary"></i>
					</span>
				)}
				{SelectedKey == rowdata.id && (
					<span className="al-icon-col" onClick={this.onDel.bind(this, rowdata)}>
						<i className="fa fa-times-circle-o fa-lg text-danger"></i>
					</span>
				)}
				{nextLevel && nextLevel.label && SelectedKey == rowdata.id && (
					<span className="al-icon-col" onClick={this.onAdd.bind(this, rowdata, nextLevel, 'Add')}>
						<i className="fa fa-plus-circle fa-lg text-success"></i>
						{t(' Add')} {t(nextLevel.label)}
					</span>
				)}
			</div>
		)
		if (rowdata.status != 'Deleted') {
			return (
				rowdata.label &&
				rowdata.name && (
					<TreeNode title={customLabel(rowdata.label)} key={rowdata.id}>
						{rowdata && rowdata.children.map((child, index) => this.renderUi(child, true, index))}
					</TreeNode>
				)
			)
		}
		return
	}
	onSubmit(formValues) {
		let { t } = this.props
		this.props.onSubmit(formValues, t)
		this.setState({ modal: false })
	}
	onDelete(item) {
		let { t } = this.props
		this.props.onDelete(item, t)
		this.setState({ deleteModal: false, deleteModalData: null })
	}

	render() {
		const { t } = this.props
		const { treeData, modal, modalData, formFields, error, levelLabels, deleteModal, deleteModalData } = this.state
		var children = this.getNestedChildren(treeData, null)
		let parentLevel = levelLabels && Array.isArray(levelLabels) && levelLabels.find(x => x.level && x.level == 1)

		return (
			<div className="category-tree">
				{error && <span className="text-danger">{error}</span>}
				<div className="add-parent" onClick={this.onAddParent.bind(this, parentLevel)}>
					<i className="fa fa-plus-circle fa-lg text-success"></i>&nbsp;
					{t('Add New')} {parentLevel && parentLevel.label ? t(parentLevel.label) : ''}
				</div>
				<Tree
					// {...this.props}
					className="myCls"
					showLine
					defaultExpandedKeys={this.state.defaultExpandedKeys}
					onExpand={this.onExpand}
					defaultSelectedKeys={this.state.defaultSelectedKeys}
					defaultCheckedKeys={this.state.defaultCheckedKeys}
					onSelect={this.onSelect}
					onCheck={this.onCheck}
					defaultExpandAll={false}
					checkable={false}
					selectable={true}
					checkStrictly={false}
					defaultExpandParent={true}
					showIcon={false}
					selectedKeys={this.state.selectedKeys}>
					{children &&
						children.map((item, index) => {
							return this.renderUi(item, false, index)
						})}
				</Tree>

				{modal && (
					<CategoryModal
						{...this.props}
						modal={modal}
						toggleModal={this.toggleModal.bind(this)}
						modalData={modalData}
						formFields={formFields}
						onSubmit={this.onSubmit.bind(this)}
						t={this.props.t}
					/>
				)}
				{deleteModal && (
					<DeleteModal
						{...this.props}
						modal={deleteModal}
						modalData={deleteModalData}
						toggleModal={this.toggleDeleteModal.bind(this)}
						onSubmit={this.onDelete.bind(this)}
						t={this.props.t}
					/>
				)}
			</div>
		)
	}
}

export const TreeView = withTranslation()(TreeView1)

const CategoryModal = props => {
	const {
		className,
		modalData: { item, action },
		formFields,
		t,
	} = props

	const [modal, setModal] = useState(props.modal)
	const [formValues, setFormValues] = useState(item)

	const toggle = () => {
		props.toggleModal(!modal)
	}
	const handleChange = event => {
		let formValue = { ...formValues, [event.target.name]: event.target.value }
		setFormValues(formValue)
	}

	const onSubmit = () => {
		props.onSubmit(formValues)
	}
	return (
		<div>
			<Modal isOpen={modal} toggle={toggle} className={className}>
				<ModalHeader toggle={toggle}>{t(action.ModalHeader) || ''}</ModalHeader>
				<ModalBody>
					{formFields &&
						typeof formFields === 'object' &&
						Object.keys(formFields).map((field, idx) => {
							return (
								<div key={idx}>
								
									{/* <Label>Name :: <span>{formValues.name || formValues.label || ''}</span></Label> */}

									<Label>{t(formFields[field].label) || t('Enter')}</Label>
									<Input
										type={formFields[field].type || ''}
										placeholder={t(formFields[field].placeholder) || ''}
										value={formValues[formFields[field].name || '']}
										name={formFields[field].name || ''}
										required={formFields[field].required || false}
										readOnly={formFields[field].readOnly || false}
										onChange={handleChange.bind(this)}
									/>
								</div>
							)
						})}
				</ModalBody>
				<ModalFooter>
					<Button outline color="primary" onClick={onSubmit.bind(this)}>
						{t(action.buttonLabel)}
					</Button>{' '}
					<Button outline color="secondary" onClick={toggle}>
						{t('Cancel')}
					</Button>
				</ModalFooter>
			</Modal>
		</div>
	)
}

const DeleteModal = props => {
	const {
		modalData: { item, message, action },
		t,
	} = props

	const [modal, setModal] = useState(props.modal)
	const toggle = () => {
		props.toggleModal(!modal)
	}

	const onDelete = item => {
		props.onSubmit(item)
		toggle()
	}
	return (
		<Modal isOpen={modal} toggle={toggle}>
			<ModalHeader toggle={toggle}>
				{t('Delete') + ' '} {t(item.label) || ''}
			</ModalHeader>
			<ModalBody>{t(message || 'Are you sure to Delete ? ')}</ModalBody>
			<ModalFooter>
				<Button outline color="secondary" onClick={toggle}>
					<i className="fa fa-ban fa-lg"></i> {t('Cancel')}
				</Button>
				{action && (
					<Button outline color="danger" onClick={onDelete.bind(this, item)}>
						<i className="fa fa-trash fa-lg"></i> {t('Delete')}
					</Button>
				)}
			</ModalFooter>
		</Modal>
	)
}
